export const colorsData = [
    { id: 'red', label: 'Red', hex: '#FF0000', text: 'Red' },
    { id: 'blue', label: 'Blue', hex: '#0000FF', text: 'Blue' },
    { id: 'green', label: 'Green', hex: '#008000', text: 'Green' },
    { id: 'yellow', label: 'Yellow', hex: '#FFFF00', text: 'Yellow' },
    { id: 'orange', label: 'Orange', hex: '#FFA500', text: 'Orange' },
    { id: 'purple', label: 'Purple', hex: '#800080', text: 'Purple' },
    { id: 'pink', label: 'Pink', hex: '#FFC0CB', text: 'Pink' },
    { id: 'black', label: 'Black', hex: '#000000', text: 'Black' },
    { id: 'white', label: 'White', hex: '#FFFFFF', text: 'White' },
    { id: 'brown', label: 'Brown', hex: '#A52A2A', text: 'Brown' },
    { id: 'gray', label: 'Gray', hex: '#808080', text: 'Gray' }
];
